import { Alert, Button, Card, TextField } from '@cartly/ui';
import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router';
import { api } from '../api/client';
import { useSubmit } from '../app/hooks';
import { useSession } from '../app/session';
import { Logo } from '../components/Logo';

/** Lands here from the embedded Shopify app ("Link to a Cartly360 account"). */
export function ConnectShopifyPage() {
  const { refresh } = useSession();
  const navigate = useNavigate();
  const [code, setCode] = useState(
    () => new URLSearchParams(window.location.search).get('code') ?? '',
  );
  const submit = useSubmit();

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    const res = await submit.run(() =>
      api.post<{ tenantId: string; storeId: string }>('/shopify/claim', { code }),
    );
    if (!res) return;
    await refresh();
    navigate(`/stores/${res.storeId}`, { replace: true });
  };

  return (
    <div className="page-center">
      <div className="onboarding">
        <Logo variant="wordmark" className="onboarding__logo" />
        <div className="onboarding__intro">
          <h1 className="page-header__title">Link your Shopify store</h1>
          <p className="page-header__description">
            Enter the code shown in the Cartly360 app inside your Shopify admin. You'll become an
            owner of that store's organization.
          </p>
        </div>
        <Card>
          <form className="stack" onSubmit={onSubmit} noValidate>
            {submit.error && <Alert tone="critical">{submit.error}</Alert>}
            <TextField
              label="Link code"
              className="input--code"
              placeholder="ABCDE-FGHJK"
              autoComplete="off"
              autoCapitalize="characters"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              error={submit.fieldErrors['code']}
              autoFocus
            />
            <div className="form-actions">
              <Link to="/stores" className="btn btn--ghost">
                Cancel
              </Link>
              <Button
                type="submit"
                variant="primary"
                loading={submit.pending}
                disabled={code.trim().length < 8}
              >
                Link store
              </Button>
            </div>
          </form>
        </Card>
      </div>
    </div>
  );
}
